import AbstractEventCatcher from '../AbstractEventCatcher';
import { addNotificationAction } from '../../../store/notifications/actions';
import eventBus, { EVENT_LIST } from '../../../utils/eventBus/eventBus';

class InternalRequestNotificationsEventCatcher extends AbstractEventCatcher {
  static IR_UPDATE_TYPES = Object.freeze({
    IR_CREATED: 'internalRequestCreated',
    IR_SUBMITTED: 'internalRequestSubmitted',
    IR_APPROVED: 'internalRequestApproved',
    IR_REJECTED: 'internalRequestRejected',
    IR_PENDING_CLOSED: 'internalRequestPendingClosed',
    IR_CLOSED: 'internalRequestClosed',
  });

  static IR_UPDATE_TYPES_AS_ARRAY = Object.freeze(
    Object.values(this.IR_UPDATE_TYPES)
  );

  static emitEventBus() {
    eventBus.$emit(EVENT_LIST.REFRESH_INTERNAL_REQUESTS_LIST);
  }

  static process(notificationInfo, dispatch) {
    this.emitEventBus();
    dispatch(addNotificationAction(notificationInfo));
  }
}

export default InternalRequestNotificationsEventCatcher;
